import { useMutation } from "@tanstack/react-query";
import { validateSevenRoomsCredentials } from "../../api/bSevenroomsApi";

export const useValidateSevenRooms = () => {
  return useMutation({
    mutationKey: ["validate-sevenrooms"],
    mutationFn: (data) => validateSevenRoomsCredentials(data),
    onError: (error) => {
      console.error("SevenRooms validation error details:", error.response || error);
    },
  });
};
